const businessHoursContent = {
  text: `7 am - 4 pm PT`,
  slug: `N/A`
} as const;

export default businessHoursContent;
